import React from 'react'

const Title = ({ value, classes }) => (
  <>
    <h1 className={`title ${classes || ''}`}>{value}</h1>
    <div className="headline-separator" aria-hidden="true"></div>
  </>
)

export default Title
